export default __webpack_public_path__ + "f06752f99eb430bbe5cbb8646c54e80f.svg";